import PropTypes from 'prop-types'
import { observer } from 'mobx-react-lite'
import { Divider } from 'ui-components-web'

import { Prescriber, Pharmacy, Medications, Patient, Observation } from './components'
import { SectionHeader } from '../../common'

import useStyles from './styles'

const PrescriptionsSection = ({ visit, onEdit, title }) => {
  const classes = useStyles()

  if (!visit) {
    return null
  }

  const { providerName, rxs } = visit

  /* Prescriptions section marked as valid (should be shown)
   only if provider added at least one rx */
  if (!rxs.length) {
    return null
  }

  return (
    <>
      <SectionHeader title={title} onEdit={onEdit} />

      <div className={classes.contentContainer}>
        <div className={classes.leftColumn}>
          <Prescriber providerName={providerName} />
          <Pharmacy rxs={rxs.uniqueRxsByPharmacy} />
          <Medications rxs={rxs} />
        </div>

        <div className={classes.rightColumn}>
          <Patient visit={visit} />
          <Observation visit={visit} />
        </div>
      </div>

      <Divider />
    </>
  )
}

PrescriptionsSection.propTypes = {
  title: PropTypes.string,
  visit: PropTypes.object,
  onEdit: PropTypes.func,
}
PrescriptionsSection.defaultProps = {
  title: '',
  visit: {},
  onEdit: () => {},
}

export default observer(PrescriptionsSection)
